export const consultantPage = {
    consultantPageQuestionLinkDesktop: {
        rbmail: {
            type: 'click',
            id: '28663859',
        },
    },
    consultantPageQuestionRubricLinkDesktop: {
        rbmail: {
            type: 'click',
            id: '28663856',
        },
    },
    consultantPageQuestionLinkTouch: {
        rbmail: {
            type: 'click',
            id: '28663929',
        },
    },
} as const;
